import React from 'react';

type CodeId = number | string;

type EventTypeObj = {
  codeDesc: string;
  codeId: CodeId;
};

type EventTypeProps = {
  eventTypeCode?: CodeId;
  eventTypes?: ReadonlyArray<EventTypeObj>;
};

export function EventType({ eventTypeCode = '', eventTypes = [] }: EventTypeProps) {
  const eventType = eventTypes.find((type) => {
    return type.codeId === eventTypeCode;
  });
  return <div>{eventType?.codeDesc ?? ''}</div>;
}
